export type RecordingCapability =
  | { available: true }
  | { available: false; reason: 'INSECURE_CONTEXT' | 'UNSUPPORTED_BROWSER' }

export function recordingCapability(): RecordingCapability {
  if (typeof window !== 'undefined' && !window.isSecureContext) {
    return { available: false, reason: 'INSECURE_CONTEXT' }
  }
  if (typeof navigator === 'undefined' || !navigator.mediaDevices?.getUserMedia || typeof MediaRecorder === 'undefined') {
    return { available: false, reason: 'UNSUPPORTED_BROWSER' }
  }
  return { available: true }
}

/**
 * 모바일 Safari 계열의 MP4/AAC를 우선하고, 지원되지 않으면 WebM/Opus로 내려갑니다.
 * canonical Media 형식은 서버 persistence 단계에서 별도로 확정합니다.
 */
export function selectRecordingMimeType(): string {
  if (typeof MediaRecorder === 'undefined' || typeof MediaRecorder.isTypeSupported !== 'function') return ''
  const candidates = [
    'audio/mp4;codecs=mp4a.40.2',
    'audio/mp4',
    'audio/webm;codecs=opus',
    'audio/webm',
    'audio/ogg;codecs=opus',
  ]
  return candidates.find((candidate) => MediaRecorder.isTypeSupported(candidate)) ?? ''
}
